import { Pipe, PipeTransform } from '@angular/core';
import {
  addMinutes,
  formatDistance,
  fromUnixTime,
  getUnixTime,
} from 'date-fns';
import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import { de, enUS } from 'date-fns/locale';
import {
  getNewUnixTimestamp,
  removeTimeZoneOffset,
} from 'server/shared/helpers/removeTimeZoneOffset';
import { TranslationKeyTranslation } from 'server/shared/models/translation';

@Pipe({
  name: 'transferTime',
  pure: false,
})
export class TransferTimePipe implements PipeTransform {
  transform(
    transferTimeUtc: number,
    options: {
      showPast?: boolean;
      directTransfer?: boolean;
      locale?: string;
      i18n?: TranslationKeyTranslation;
    },
  ): string {
    const nowUnix = getNewUnixTimestamp();

    if (options.directTransfer) {
      const now = new Date();
      const transferTime = addMinutes(fromUnixTime(transferTimeUtc), 1);
      if (now < transferTime) {
        return formatDistanceStrict(transferTime, now, {
          addSuffix: true,
          locale: options?.locale === 'en' ? enUS : de,
        });
      } else {
        return options.i18n?.soon?.toString() || 'bald';
      }
    }

    if (transferTimeUtc <= nowUnix && options.showPast == false) {
      return options.i18n?.immediately?.toString() || 'sofort';
    }

    return formatDistance(fromUnixTime(transferTimeUtc), new Date(), {
      addSuffix: true,
      locale: options?.locale === 'en' ? enUS : de,
    });
  }
}

@Pipe({
  name: 'transferDateTime',
  pure: false,
})
export class TransferTimePipeWithDate implements PipeTransform {
  transform(
    transferTimeUtc: Date,
    options: {
      showPast?: boolean;
      directTransfer?: boolean;
      locale?: string;
      i18n?: TranslationKeyTranslation;
    },
  ): string {
    const nowUtc = removeTimeZoneOffset(new Date());
    const nowUtcUnix = getUnixTime(nowUtc);

    if (options.directTransfer) {
      const now = new Date();
      const transferTime = addMinutes(transferTimeUtc, 1);
      if (now < transferTime) {
        return formatDistanceStrict(transferTime, now, {
          addSuffix: true,
          locale: options?.locale === 'en' ? enUS : de,
        });
      } else {
        return options.i18n?.soon?.toString() || 'bald';
      }
    }

    if (
      getUnixTime(transferTimeUtc) <= nowUtcUnix &&
      options.showPast == false
    ) {
      return options.i18n?.immediately?.toString() || 'sofort';
    }

    return formatDistance(removeTimeZoneOffset(transferTimeUtc), nowUtc, {
      addSuffix: true,
      locale: options?.locale === 'en' ? enUS : de,
    });
  }
}
